import ReactGA from 'react-ga4';

import Background from 'assets/header-bg.png';

import Button from '@mui/material/Button';
import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles(() =>
    createStyles({
        header: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background:
                'linear-gradient(180deg, rgba(31, 32, 81, 0.4) 0%, rgba(31, 32, 81, 0.6) 48.96%, #1F2051 100%)',
            height: 'auto',
            position: 'relative',
            width: '100%',
            '& > img': {
                height: '100%',
                objectFit: 'cover',
                width: '100%',
                maxHeight: '300px',
                minHeight: '200px'
            }
        },
        subtitleContainer: {
            position: 'absolute',
            bottom: '16%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '16px',
            zIndex: 3,
            '@media (max-width: 768px)': {
                bottom: '-16%'
            }
        },
        subtitle: {
            color: '#FFFFFF',
            fontSize: '20px',
            fontWeight: 500,
            lineHeight: '29px'
        },
        signupBtn: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background:
                'linear-gradient(0deg, #9897E3, #9897E3), linear-gradient(270deg, rgba(184, 194, 255, 0.75) 0%, rgba(184, 194, 255, 0) 100%)',
            borderRadius: '50px',
            color: '#FFFFFF',
            fontSize: '18px',
            fontWeight: 800,
            lineHeight: '25px',
            padding: '16px 28px',
            textTransform: 'none',
            width: '100%',
            '& i': {
                fontSize: '18px'
            },
            '&:disabled': {
                color: '#FFFFFF !important',
                opacity: 0.6,
                cursor: 'not-allowed'
            }
        }
    })
);

const ListHeader = ({
    setEligibilityPopUp,
    shouldShowSignupButton = false,
    shouldDisableSignupButton = false
}: {
    setEligibilityPopUp: (open: boolean) => void;
    shouldShowSignupButton?: boolean;
    shouldDisableSignupButton?: boolean;
}) => {
    const classes = useStyles();

    const handleEligibilityCheckClick = () => {
        ReactGA.event({
            category: 'Navigation',
            action: 'Click',
            label: 'Check Member Eligibility Button'
        });

        setEligibilityPopUp(true);
    };

    return (
        <header className={classes.header}>
            <img src={Background} alt="header" />
            {shouldShowSignupButton && (
            <div className={classes.subtitleContainer}>
                <span className={classes.subtitle}>
                    Reward and support client progress
                </span>
                <Button
                    className={classes.signupBtn}
                    onClick={
                        handleEligibilityCheckClick
                    }
                    disabled={shouldDisableSignupButton}
                    aria-label="Sign Up a New Member Button and Navigate to Member Registration"
                >
                    Sign Up New Member
                    <i className="fas fa-arrow-right" />
                </Button>
            </div>
            )}
        </header>
    );
};

export default ListHeader;